import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store' // Make sure this is imported
import ganttastic from '@infectoone/vue-ganttastic'
// FontAwesome webfont CSS — the app renders icons via <i class="fas fa-…"> markup
// everywhere, which needs this stylesheet (the SVG-core library below only covers
// the handful of <font-awesome-icon> components).
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@/styles/globalOrderStyles.scss'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
    faEye,
    faEdit,
    faTrash,
    faFilter,
    faUndo,
    faClipboardList
} from '@fortawesome/free-solid-svg-icons'
library.add(faEye, faEdit, faTrash, faFilter, faUndo, faClipboardList)


// Use the environment variable, not hardcoded
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || '/'

// Create the app with router
const app = createApp(App)
app.use(router)
app.use(store)
app.use(ganttastic)
app.component('font-awesome-icon', FontAwesomeIcon)
app.mount('#app')
